import moment from 'moment-timezone'

type GetTimeResultT = {
  from: string
  to: string | null
}
type GetTimeParamsT = {
  timeFrom: string
  timeTo: string
  minutesAmount?: number
  timeZone?: string
}

type GetTimeT = (value: GetTimeParamsT) => GetTimeResultT

const getFormattedTimeWithAddedMinutes: GetTimeT = ({
  timeFrom,
  timeTo,
  minutesAmount = 15,
}: GetTimeParamsT) => {
  const result: GetTimeResultT = {
    from: moment(timeFrom, 'h:mm a').format('HH:mm'),
    to: null,
  }

  if (moment(timeFrom).isSameOrAfter(moment(timeTo))) {
    result.to = moment(timeFrom, 'h:mm a').add(minutesAmount, 'minutes').format('HH:mm')
  }

  return result
}

export default getFormattedTimeWithAddedMinutes
